import { render, staticRenderFns } from "./ButtonEdit.vue?vue&type=template&id=67360f09&scoped=true"
import script from "./ButtonEdit.vue?vue&type=script&lang=js"
export * from "./ButtonEdit.vue?vue&type=script&lang=js"
import style0 from "./ButtonEdit.vue?vue&type=style&index=0&id=67360f09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67360f09",
  null
  
)

export default component.exports